// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"93f6b40b","239":"02584959","453":"cd3babd1","455":"f0cbdd19"}[chunkId] + ".chunk.js";
};